var __jsx = React.createElement;
import React from "react";
import { ELSTypography } from "components/common/elsevier/Typography/Typography";
import styles from "./Layout.module.scss";

/**
 *
 * @param {title} title Indicates to use a "banner" title for the page
 * @param {isPublic} isPublic Indicates if the page is public facing
 * @param {children} children Chidren to output in layout "main" element
 *
 * @returns JSX
 */
function Layout(_ref) {
  var pageTitle = _ref.pageTitle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, pageTitle && /*#__PURE__*/React.createElement(ELSTypography, {
    className: styles["ev-pageheader"],
    component: "h1",
    variant: "h2"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.main
  }, children));
}
export default Layout;